module.exports = __webpack_public_path__ + "static/media/room-bgd.c0da1704.png";